import { __awaiter, __generator, __read, __spread } from "tslib";
import React, { useEffect, useState } from 'react';
import { app } from '@ekuaibao/whispered';
import styles from './filter.module.less';
import { Loading } from './columnOthers';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Checkbox, ErrorBlock, List, Tag, Tooltip } from '@hose/eui';
import EkbHighLighter from '../EkbHighLighter';
import { getDisplayName } from '../utilFn';
import { IllustrationSmallNoSearch } from '@hose/eui-icons';
import { useDepartmentVisible } from '../../lib/featbit';
import { queryDepartmentDataInWeComISV } from './DepartmentList.wecom';
import { NameCell } from '../name-cell';
var countPerPage = 100;
var filterScope;
var DepartmentList = function (_a) {
    var _b = _a.value, value = _b === void 0 ? [] : _b, isInit = _a.isInit, initList = _a.initList, searchStr = _a.searchStr, departmentPathMap = _a.departmentPathMap, onChange = _a.onChange;
    var _c = __read(useState(0), 2), searchCount = _c[0], setSearchCount = _c[1];
    var _d = __read(useState(initList !== null && initList !== void 0 ? initList : []), 2), searchList = _d[0], setSearchList = _d[1];
    var _e = __read(useState(false), 2), loading = _e[0], setLoading = _e[1];
    var _f = __read(useState(1), 2), page = _f[0], setPage = _f[1];
    useEffect(function () {
        if (!isInit) {
            fetchData(1);
        }
    }, [searchStr]);
    useEffect(function () {
        if (isInit) {
            setSearchList(initList);
        }
    }, [initList]);
    var fetchData = function (page) { return __awaiter(void 0, void 0, void 0, function () {
        var contactConfig, params, result, items, count, data;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!searchStr || loading) {
                        return [2];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, , 5, 6]);
                    if (!!filterScope) return [3, 3];
                    return [4, app.dataLoader('@contactManagement.contactConfig').load()];
                case 2:
                    contactConfig = _c.sent();
                    filterScope = contactConfig === null || contactConfig === void 0 ? void 0 : contactConfig.filterScope;
                    _c.label = 3;
                case 3:
                    setLoading(page === 1);
                    params = getParams(searchStr, value, page);
                    return [4, (window.isInWeComISV ? queryDepartmentDataInWeComISV(searchStr) : app.invokeService('@contacts:search:departments:list', params))];
                case 4:
                    result = _c.sent();
                    items = (_a = result === null || result === void 0 ? void 0 : result.items) !== null && _a !== void 0 ? _a : [];
                    count = (_b = result === null || result === void 0 ? void 0 : result.count) !== null && _b !== void 0 ? _b : 0;
                    data = __spread(items);
                    if (page > 1) {
                        data = __spread(searchList, items);
                    }
                    setSearchList(data);
                    setSearchCount(count);
                    setLoading(false);
                    return [3, 6];
                case 5:
                    setLoading(false);
                    return [7];
                case 6: return [2];
            }
        });
    }); };
    var loadMoreData = function () {
        setPage(page + 1);
        fetchData(page + 1);
    };
    var handleItemChange = function (checked, item) {
        var checkedData = __spread(value);
        if (checked) {
            checkedData.push(item.id);
        }
        else {
            checkedData = checkedData.filter(function (id) { return id !== item.id; });
        }
        onChange('list', checkedData, item);
    };
    return (React.createElement("div", { className: styles['list-wrapper'], id: "scrollableDiv" }, loading ? (React.createElement(Loading, null)) : ((searchStr && searchList.length === 0)
        ? React.createElement(EmptyBlock, null)
        : React.createElement(InfiniteScroll, { dataLength: searchList.length, next: loadMoreData, hasMore: searchList.length < searchCount, loader: React.createElement("div", null), scrollableTarget: "scrollableDiv" },
            React.createElement(List, { dataSource: searchList, renderItem: function (item) {
                    var path = departmentPathMap[item.id];
                    return (React.createElement("div", { className: styles['list-item'], onClick: function (e) { return handleItemChange(!value.includes(item.id), item); } },
                        React.createElement(Checkbox, { checked: value.includes(item.id) }),
                        React.createElement(DepartmentTitle, { item: item, path: path, searchStr: searchStr }),
                        !item.active && React.createElement(Tag, { size: "small" }, i18n.get('已删除'))));
                } })))));
};
var EmptyBlock = function () {
    var title = filterScope === 'UNLIMITED' ? i18n.get('未匹配到部门，请精确搜索或联系管理员确认可见范围') : i18n.get('暂无数据');
    return (React.createElement(ErrorBlock, { title: title, image: React.createElement(IllustrationSmallNoSearch, null), style: {
            height: '100%',
            margin: '0 40px'
        } }));
};
var DepartmentTitle = function (_a) {
    var item = _a.item, path = _a.path, searchStr = _a.searchStr;
    var contentRef = React.createRef();
    var _b = __read(useState(false), 2), needTooltip = _b[0], setNeedTooltip = _b[1];
    var name = getDisplayName(item);
    var title = "" + name + (!!path ? "(" + path + ")" : '');
    var handleMouseEnter = function (e) {
        setNeedTooltip(contentRef.current.offsetWidth > e.target.offsetWidth);
    };
    var content = function () {
        if (window.isInWeComISV) {
            return (React.createElement("span", { ref: contentRef },
                React.createElement(NameCell, { type: "department", id: item.id, name: name })));
        }
        return (React.createElement("span", { ref: contentRef },
            React.createElement(EkbHighLighter, { highlightClassName: styles['highlight'], searchWords: [searchStr], textToHighlight: name }),
            !!path && "(" + path + ")"));
    };
    return (React.createElement("div", { className: styles['text-nowrap-ellipsis'] + " ml-4", onMouseEnter: handleMouseEnter }, needTooltip ? (React.createElement(Tooltip, { placement: "topLeft", title: title }, content())) : (content())));
};
var getParams = function (searchStr, checkedIds, page) {
    if (checkedIds === void 0) { checkedIds = []; }
    if (page === void 0) { page = 1; }
    var query = {
        limit: {
            start: (page - 1) * countPerPage,
            count: countPerPage
        },
        orderBy: [
            {
                value: 'active',
                order: 'DESC'
            },
            {
                value: 'updateTime',
                order: 'DESC'
            }
        ]
    };
    var filterBy = '';
    if (searchStr) {
        var lowerStr = searchStr.toLowerCase();
        if (useDepartmentVisible() && filterScope === 'UNLIMITED') {
            filterBy = "name==(\"" + searchStr + "\")||enName==(\"" + searchStr + "\")";
        }
        else {
            filterBy =
                i18n.currentLocale === 'zh-CN'
                    ? "lower(name).containsIgnoreCase(\"" + lowerStr + "\")||lower(nameSpell).containsIgnoreCase(\"" + lowerStr + "\")||lower(nameInitial).containsIgnoreCase(\"" + lowerStr + "\")"
                    : "lower(enName).containsIgnoreCase(\"" + lowerStr + "\")";
        }
    }
    if (checkedIds.length) {
        var ids = checkedIds.map(function (item) { return "\"" + item + "\""; });
        filterBy = (!!filterBy ? filterBy + "||" : '') + "id.in(" + ids.join(',') + ")";
    }
    if (!!filterBy) {
        query.filterBy = filterBy;
    }
    if (useDepartmentVisible()) {
        query.visible = filterScope !== 'UNLIMITED';
    }
    return query;
};
export default DepartmentList;
